import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import CheckBox from "../../../../components/checkBox/CheckBox";
import SelectOption from "../../../../components/selectOption/SelectOption";
import TextInput from "../../../../components/textInput/TextInput";
import TextInfo from "../../../../components/textInfo/TextInfo";
import SearchBar from "../../../../components/searchBar/SearchBar";
import {
  getDataWithProductAttributes,
  getNatureOfComplaints,
  getCustomerIdentity,
} from "../../../../store/actions/fault.action";
import MainLoader from "../../../../components/loading/MainLoader";
import AlertModal from "../../../../components/alertModal/alertModal";

interface IProps {
  onSubmit: (data: IServiceComplainsFormInputs) => void;
  onChangeCCTID: (e: any) => void;
  technicalContacts: any;
}

export enum EInputMode {
  primary,
  light,
}

export interface IServiceComplainsFormInputs {
  CCTID: string;
  serviceId: string;
  technicalContact: string;
  remark: string;
  natureOfFault: string;
}

interface IErrorResponse {
  result: boolean;
  message: string;
  displayMessage: string;
  statusCode: number;
  isSuccess: boolean;
}

const ServiceComplaint = (props: IProps) => {
  const {
    register,
    control,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<IServiceComplainsFormInputs>();
  const [cpePowerOn, setCpePowerOn] = useState<boolean>(false);

  useEffect(() => {
    if (Object.keys(props.technicalContacts).length !== 0) {
      setValue(
        "technicalContact",
        props.technicalContacts.technicalContactMobileNo
      );
    }
  }, [props.technicalContacts, setValue]);

  const [isLoading, setIsLoading] = useState(false);

  const [isVerrified, setIsVerified] = useState(false);

  const [service, setService] = useState("");

  const [serviceDisplay, setServiceDisplay] = useState("");

  const [mobile, setMobile] = useState("");

  const [natureOfFaults, setNatureOfFaults] = useState([]);

  const [showAlert, setShowAlert] = useState(false);

  const [error, setError] = useState("");

  const [ServiceID, setServiceIDValue] = useState("");

  useEffect(() => {
    if (ServiceID) {
      setValue("serviceId", ServiceID);
    }
  }, [ServiceID, setValue]);

  useEffect(() => {
    if (service) {
      setValue("CCTID", service);
    }
  }, [service, setValue]);

  useEffect(() => {
    if (mobile) {
      setValue("technicalContact", mobile.match(/\d{1,10}/)?.[0] || "");
    }
  }, [mobile, setValue]);

  const handle = (value: string) => {
    if (!value) {
      return;
    }

    setIsLoading(true);
    // Validate User
    getCustomerIdentity(value)
      .then((response) => {
        setIsVerified(true);

        setServiceIDValue(value);
        // Get Prduct Attributes
        getDataWithProductAttributes(value)
          .then((response) => {
            if (response?.status !== "Active") {
              // Reset all state variables
              setService("");
              setServiceDisplay("");
              setMobile("");
              setServiceIDValue("");
              setNatureOfFaults([]);

              // Reset form values
              setValue("CCTID", "");
              setValue("serviceId", "");
              setValue("technicalContact", "");
              setValue("natureOfFault", "");
              setValue("remark", "");
              setIsLoading(false);
              setIsVerified(false);
              setShowAlert(true);
              const errorMessage =
                "User Account is Suspended. Please Contact SLT Team";

              setError(errorMessage);
            } else {
              setService(response?.sltossServiceType);
              setMobile(response?.technicalContactMobileNo);
            }

            // call nature of complain api to get nature of complain list
            getNatureOfComplaints(response?.sltossServiceType)
              .then((response) => {
                if (!response.dataBundle || response.dataBundle.length === 0) {
                  setIsLoading(false);
                  setIsVerified(false);
                  // Reset all state variables
                  setService("");
                  setServiceDisplay("");
                  setMobile("");
                  setServiceIDValue("");
                  setNatureOfFaults([]);

                  // Reset form values
                  setValue("CCTID", "");
                  setValue("serviceId", "");
                  setValue("technicalContact", "");
                  setValue("natureOfFault", "");
                  setValue("remark", "");
                  setShowAlert(true);
                  const errorMessage =
                    response.errorMessage || "An unexpected error occurred";

                  setError(errorMessage);
                } else {
                  setNatureOfFaults(response.dataBundle);
                  setServiceDisplay(response.dataBundle[0].displayServiceType);
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                setIsLoading(false);
                // Reset all state variables
                setService("");
                setServiceDisplay("");
                setMobile("");
                setServiceIDValue("");
                setNatureOfFaults([]);

                // Reset form values
                setValue("CCTID", "");
                setValue("serviceId", "");
                setValue("technicalContact", "");
                setValue("natureOfFault", "");
                setValue("remark", "");
              });
          })
          .catch((error) => {
            // Reset all state variables
            setService("");
            setServiceDisplay("");
            setMobile("");
            setServiceIDValue("");
            setNatureOfFaults([]);

            // Reset form values
            setValue("CCTID", "");
            setValue("serviceId", "");
            setValue("technicalContact", "");
            setValue("natureOfFault", "");
            setValue("remark", "");
            setIsLoading(false);
          });
      })
      .catch((error) => {
        // Reset all state variables
        setService("");
        setServiceDisplay("");
        setMobile("");
        setServiceIDValue("");
        setNatureOfFaults([]);

        // Reset form values
        setValue("CCTID", "");
        setValue("serviceId", "");
        setValue("technicalContact", "");
        setValue("natureOfFault", "");
        setValue("remark", "");
        setIsLoading(false);
        setIsVerified(false);
        setShowAlert(true);

        const errorMessage = error!.message || "An unexpected error occurred";

        setError(errorMessage);
      });
  };

  return (
    <>
      <AlertModal
        show={showAlert}
        variant="error"
        buttons={[
          {
            text: "Ok",
            onClick: () => {
              setShowAlert(false);
            },
            variant: "success",
          },
        ]}
      >
        <label>{error}</label>
      </AlertModal>
      <MainLoader show={isLoading} />
      <Row className="justify-content-center mt-2 mb-5">
        <Col className="col-md-5">
          <SearchBar onSearch={handle} placeholder="Service Number /  ID" />
        </Col>
      </Row>
      <form
        onSubmit={handleSubmit(props.onSubmit)}
        className="poppins-semibold"
        style={{
          opacity: isVerrified ? 1 : 0.6,
          pointerEvents: isVerrified ? "auto" : "none",
          filter: isVerrified ? "none" : "blur(2px)",
          backgroundColor: isVerrified ? "white" : "#f0f0f0",
          transition: "all 0.3s ease-in-out",
          padding: "15px",
          borderRadius: "8px",
        }}
      >
        <Row className="row-cols-1 row-cols-md-2 gy-3">
          <Col>
            <TextInput
              disabled
              label="Service"
              required
              color="gray"
              mode={EInputMode.light}
              value={serviceDisplay}
              useFormRegister={{ ...register("CCTID", { required: true }) }}
              maxLength={15}
              onBlur={(e) => {
                props.onChangeCCTID(e);
                console.log(e.target.value);
              }}
              errors={[
                {
                  isShow: errors.CCTID?.type === "required",
                  message: "Circuit ID required",
                },
              ]}
            />
          </Col>
          <Col>
            <Controller
              control={control}
              defaultValue={undefined}
              name="natureOfFault"
              rules={{ required: true }}
              render={({ field: { onChange } }) => (
                <SelectOption
                  onChange={(val) => {
                    onChange(val.value);
                  }}
                  required
                  label="Nature of Complaint"
                  // options={serviceFaultList.map((item: IServiceFaultItem) => ({
                  //   label: item.pid,
                  //   value: item.nof,
                  // }))}
                  options={natureOfFaults.map((item: any) => ({
                    label: item.displayFaultName,
                    value: item.natureOfFault,
                  }))}
                  errors={[
                    {
                      isShow: errors.natureOfFault?.type === "required",
                      message: "Nature of Complaint is required",
                    },
                  ]}
                />
              )}
            />
          </Col>
          <Col>
            <TextInput
              label="Technical Contact"
              color="gray"
              mode={EInputMode.light}
              value={watch("technicalContact")}
              required
              useFormRegister={{
                ...register("technicalContact", {
                  required: true,
                  pattern: /^[0][7][01245678][0-9]{7}$/gm,
                }),
              }}
              type="tel"
              inputMode="numeric"
              maxLength={10}
              errors={[
                {
                  isShow: errors.technicalContact?.type === "required",
                  message: "Technical Contact is required",
                },
                {
                  isShow: errors.technicalContact?.type === "pattern",
                  message:
                    "Contact Number must be 10 digits and start with 07XXXXXXXX",
                },
              ]}
            />
          </Col>
          <Col>
            <CheckBox
              label="Currently power is available at the location."
              checked={cpePowerOn}
              onChange={(e) => setCpePowerOn(e.target.checked)}
              style={{ marginTop: "45px" }}
            />
          </Col>
          <Col className="col-md-8">
            <TextInput
              label="Remark"
              color="gray"
              mode={EInputMode.light}
              placeholder="Brief Description (Should be limit to 80 characters)"
              useFormRegister={{ ...register("remark", { required: false }) }}
              maxLength={80}
            />
          </Col>
        </Row>
        {/* <Row className="mt-3 justify-content-center">
          <Col className="col-md-12">
            <TextInfo color="primary">
              <b>
                <i className="poppins-regular" style={{ fontStyle: "italic" }}>
         
                  Note : Currently power is available at the location.
                </i>
              </b>
            </TextInfo>
          </Col>
        </Row> */}
        <Row className="mt-5 justify-content-center">
          <Col className="col-md-3">
            <Button
              type="submit"
              className="w-100"
              style={{
                backgroundColor: "#51B848",
                borderColor: "#51B848",
                fontSize: "16px",
              }}
              disabled={!cpePowerOn}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default ServiceComplaint;
